<template>
  <div class="qr-code-container">
    <div class="qr-code">
      <div class="tabs">
        <span @click="enterClick">输入乘机人信息</span>
        <span>扫描乘机信息</span>
      </div>
      <div>
        <img @click="onClick(true)" src="../assets/scan.png" alt />
      </div>
      <div>
        <b>扫一扫</b>
      </div>
      <div class="remark">扫描识别身份证/护照，快速填写信息</div>
    </div>
    <!-- <footer>查询退改记录 <van-icon name="upgrade" /></footer> -->
    <van-popup v-model="show" position="bottom">
      <div class="select-box">
        <div>请选择您要拍摄的类型</div>
        <!-- <div @click="onClick(false, '-1')">登机牌</div> -->
        <div @click="onClick(false, '0')">二代身份证</div>
        <div @click="onClick(false, '1')">中国护照</div>
      </div>
      <div class="cancel" @click="onClick(false)">取消</div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "QrCode",
  data() {
    return {
      show: false
    };
  },
  methods: {
    enterClick() {
      this.$router.push({
        path: "/query/general/more",
        query: this.$route.query
      });
    },
    onClick(show, cardType) {
      this.show = show;
      const { redirect } = this.$route.query;
      if (window.CSNativeObject) {
        if (cardType) {
          if (cardType === "-1") {
            window.CSNativeObject.nativeScan();
            return;
          }
          window.CSNativeScanCallback = result => {
            if (typeof result === "string") {
              result = JSON.parse(result);
            }
            let lastName = "",
              firstName = "",
              account = "";
            if (cardType === "0") {
              account = result.cardNum;
              lastName = result.fullName;
            } else if (cardType === "1") {
              account = result.cardNum;
              firstName = result.firstName;
              lastName = result.lastName;
            }
            const url = decodeURIComponent(redirect);
            window.location.href =
              `${url}${
                url.includes("?") ? "&" : "?"
              }urlParams=lastName-${lastName}_` +
              `firstName-${firstName}_` +
              `account-${account}`;
            delete window.CSNativeScanCallback;
          };
          window.CSNativeObject.nativeCardScan(
            JSON.stringify({
              cardType,
              IDCardType: "0",
              checkInfo: "0",
              scanCallBackMethod: "CSNativeScanCallback"
            })
          );
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../style/constant.less";
@import "../style/general.less";
.qr-code-container {
  > footer {
    text-align: center;
    position: absolute;
    color: #fff;
    left: 0;
    right: 0;
    bottom: 20px;
    font-size: 15px;
  }
  > .van-popup {
    background-color: transparent;
  }
}
.qr-code {
  @box();
  padding: 30px 0 45px;
  text-align: center;
  > .tabs {
    > span {
      border: 1px solid #3c88c5;
      color: #3c88c5;
      font-size: @font-sm-size;
      padding: 8px 16px;
      &:first-child {
        border-radius: 6px 0 0 6px;
        border-right-width: 0;
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
        border-left-width: 0;
        color: #fff;
        background-color: #3c88c5;
      }
    }
  }
  img {
    margin: 60px 0 21px;
    width: 100px;
    height: 100px;
  }
  b {
    color: #333;
    font-size: 15px;
  }
  > .remark {
    font-size: @font-sm-size;
    margin-top: 68px;
  }
}
.select-box {
  @box();
  box-shadow: inherit;
  > div {
    font-size: @font-md-size;
    color: #3478f6;
    text-align: center;
    border-bottom: 1px solid #2684e5;
    height: 54px;
    line-height: 54px;
    &:first-child {
      font-size: @font-smd-size;
      color: #8f8f8f;
      height: 42px;
      line-height: 42px;
      border-bottom: 1px solid #aec6db;
    }
    &:last-child {
      border-bottom-width: 0;
    }
  }
}
.cancel {
  @box();
  font-size: @font-md-size;
  color: #3478f6;
  text-align: center;
  border-bottom: 1px solid #2684e5;
  height: 54px;
  line-height: 54px;
  margin: 8px auto;
  box-shadow: inherit;
}
</style>
